import React from 'react'
import { VndlyCandidateIssuesProvider } from './context/VndlyCandidateIssuesProvider'
import { VndlyCandidateIssuesMain } from './components/VndlyCandidateIssuesMain'

export const VndlyCandidateIssues = () => {
  return (
    <VndlyCandidateIssuesProvider>
      <VndlyCandidateIssuesMain />
    </VndlyCandidateIssuesProvider>
  )
}
